import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const tradeReconciliationRouters: RouteRecordRaw[] = [
    {
        path: "/tradeReconciliation",
        name: "TradeReconciliation",
        meta: {
            title: "结算管理",
            activeMenu: "TradeReconciliation",
            pageType: PAGE_TYPE.LIST.code,
            keepAlive: true
        },
        component: () => import("@/views/pages/tradeManagement/reconciliation/index.vue")
    },
    {
        path: "/tradeReconciliation/tradeReconciliationDetail",
        name: "TradeReconciliationDetail",
        meta: { title: "结算详情", hidden: true, activeMenu: "TradeReconciliation" },
        component: () => import("@/views/pages/tradeManagement/reconciliation/detail.vue")
    },
    {
        path: "/tradeReconciliation/tradeReconciliationAdd",
        name: "TradeReconciliationAdd",
        meta: { title: "新增结算", hidden: true, activeMenu: "TradeReconciliation" },
        component: () => import("@/views/pages/tradeManagement/reconciliation/form.vue")
    },
    {
        path: "/tradeReconciliation/tradeReconciliationEdit",
        name: "TradeReconciliationEdit",
        meta: { title: "修改结算", hidden: true, activeMenu: "TradeReconciliation" },
        component: () => import("@/views/pages/tradeManagement/reconciliation/form.vue")
    }
];

export default tradeReconciliationRouters;
